module.exports = __webpack_public_path__ + "static/media/Noosa.b30bf080.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Noosa.jpg
// module id = 648
// module chunks = 0